import { LocalVideoTrack } from 'livekit-client';
import { localTracksStore } from 'state/store/localTracks/localTracks';

export const setLocalVideoTrack = (localVideoTrack: LocalVideoTrack | null) => {
    localTracksStore.setLocalVideoTrack(localVideoTrack);
};
